// extracted by mini-css-extract-plugin
export default {"placeholder":"placeholder-loader_placeholder__iyy3W","pulse":"placeholder-loader_pulse__bcptU","dark_placeholder":"placeholder-loader_dark_placeholder__YVLUZ"};